import * as React from "react";
// import DigitalCheckOutPage from "../../src/Digital/CheckOut/DigitalCheckOutPage";

import dynamic from "next/dynamic";
import { GetStaticProps } from "next";
import { fetchStoryContent } from "functions/src/shared/Digital/Storyblok/fetchStory";
import { CheckoutTranslateStoryblok } from "functions/src/shared/Digital/StoryBlockSchema/components-schema";
import { TranslateProvider } from "../../src/i18n/useStoryblokTranslate";
import Head from "next/head";
import { fetchTranslates } from "../../lib/Storyblok/fetchTranslation";
import { SimpleContainer } from "../../src/Basic/SimpleContainer";
import { PageContainer } from "../../src/Basic/PageContainer";

const DigitalCheckOutPage = dynamic(
  () => import("../../src/Digital/CheckOut/DigitalCheckOutPage"),
  {
    ssr: false,
  }
);
export default function CheckOutRoute({
  checkoutTranlstate,
}: {
  checkoutTranlstate: CheckoutTranslateStoryblok;
}) {
  return (
    // <TranslateProvider checkoutTranslate={checkoutTranlstate}>
    <PageContainer>
      <Head>
        <title>Checkout</title>
      </Head>

      <DigitalCheckOutPage></DigitalCheckOutPage>
    </PageContainer>
    // </TranslateProvider>
  );
}

export const getStaticProps: GetStaticProps = async ({
  params,
  locale,
  // previewData,
  preview,
}) => {
  try {
    // let checkoutTranlstate =
    //   await fetchStoryContent<CheckoutTranslateStoryblok>({
    //     full_slug: "translate/checkout-translate",
    //     locale,
    //   });

    return {
      props: {
        translate: await fetchTranslates(
          ["commontranslate", "checkout-translate"],
          locale
        ),
        // checkoutTranlstate: checkoutTranlstate,
      },
    };
  } catch (e) {
    console.log(e);
  }
};
